import {Client} from "@stomp/stompjs";

const SendCommandToRabbit = (destination, publishModel, userId = "hilight") => {
    const client = new Client({
        brokerURL: `ws://${window.location.hostname}:15674/ws`,
        connectHeaders: {
            login: "guest",
            passcode: "guest",
            'client-id': 'ppt-'+ userId
        },
        reconnectDelay: 4000
    });

    client.onConnect = (frame) => {
        client.publish({
            destination: destination,
            body: JSON.stringify(publishModel)
        });
        client.deactivate();
    };

    client.onStompError = (frame) => {
        console.log('Broker reported error: ' + frame.headers['message']);
        console.log('Additional details: ' + frame.body);
    };

    client.activate();
};

export const SendPlay = (hostname) => {
    const destination = `/exchange/amq.topic/HilightPlayerControl.${hostname}`;
    return SendCommandToRabbit(destination, {
        Command: "Play",
        Value: ""
    })
}

export const SendPause = (hostname) => {
    const destination = `/exchange/amq.topic/HilightPlayerControl.${hostname}`;
    return SendCommandToRabbit(destination, {
        Command: "Pause",
        Value: ""
    })
}

export const SendChangeLang = (hostname, langVal) => {
    const destination = `/exchange/amq.topic/HilightPlayerControl.${hostname}`;
    return SendCommandToRabbit(destination, {
        Command: "ChangeMediaAndPlayLanguage",
        Value: langVal
    })
}

export const SendChangeMediaAndPlay = (hostname, fileVal) => {
    const destination = `/exchange/amq.topic/HilightPlayerControl.${hostname}`;
    return SendCommandToRabbit(destination, {
        Command: "ChangeMediaAndPlay",
        Value: fileVal
    })
}

export const SendStop = (hostname) => {
    const destination = `/exchange/amq.topic/HilightPlayerControl.${hostname}`;
    return SendCommandToRabbit(destination, {
        Command: "Stop",
        Value: ""
    })
}

export const SendCrestron = (command) => {
    return SendCommandToRabbit(`/exchange/amq.topic/HilightPlayerControl.CinemaControl.PC-007`, {
        Type: "CRESTRON",
        Command: command
    })
}

